<template>
  <div id="relListMet">
    <div class="mt-4">
      <div class="card shadow">
        <b-card-header
          header-text-variant="white"
          header-tag="header"
          header="Média de Desempenho Mensal"
          :style="cor"
        />
        <b-card>
          <div class="title ml-3 titulo-mes" v-if="pMetasDados.descricaoMes">{{pMetasDados.descricaoMes}}</div>
          <b-table :items="tableMes" :fields="fieldsMensal" caption-top>
            <template slot="desempenho" slot-scope="row">
              <b-progress show-value  :value="row.item.percAtingido" :max="max"  variant="warning" class="mt-2 prog"></b-progress>
              <!--:variant="(row.item.percAtingido <= 33 ? 'danger' : (row.item.percAtingido <= 66 ? 'warning' : 'success'))"-->
            </template>
            <template slot="mobileGeral" slot-scope="row">
              <div class="shadow pb-1 mb-2">
                <div class="titleMob">{{pMetasDados.descricaoMes}}</div>
                <div class="contMob">
                  <b-progress show-value  :value="row.item.percAtingido" :max="max"  variant="warning" class="mb-3 prog"></b-progress>
                  <div class="form-row">
                    <div class="col-md-4">
                      <strong>Meta</strong>
                      <div>{{formatterValue(row.item.valorMeta)}}</div>
                    </div>
                    <div class="col-md-4">
                      <strong>Atingido</strong>
                      <div>{{formatterValue(row.item.valorAtingido)}}</div>
                    </div>
                    <div class="col-md-4">
                      <strong>Média</strong>
                      <div>{{formatterValue(row.item.valorMedio)}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </b-table>
          <!--<div class="title">Categorias</div>-->
          <hr>
          <b-table :items="pMetasDados.porCategoria" :fields="fieldsCategoria" caption-top v-if="pMetasDados.porCategoria && pMetasDados.porCategoria.length > 0">
            <template slot="categorias" slot-scope="row">
              <div class="txtLeft mb-1 label-categoria">{{toCapitalize(row.item.categoria)}}</div>
              <b-progress show-value  :value="row.item.percAtingido" :max="max" variant="warning" class="mb-3"></b-progress>
              <!--:variant="(row.item.percAtingido <= 33 ? 'danger' : (row.item.percAtingido <= 66 ? 'warning' : 'success'))"-->
            </template>
            <template slot="mobileCategorias" slot-scope="row">
              <div class="shadow pb-1 mb-2">
                <div class="titleMob">{{toCapitalize(row.item.categoria)}}</div>
                <div class="contMob">
                  <b-progress show-value  :value="row.item.percAtingido" :max="max" variant="warning" class="mb-3"></b-progress>
                  <div class="form-row mb-3">
                    <div class="col-md-4">
                      <strong>Meta</strong>
                      <div>{{formatterValue(row.item.valorMeta)}}</div>
                    </div>
                    <div class="col-md-4">
                      <strong>Atingido</strong>
                      <div>{{formatterValue(row.item.valorAtingido)}}</div>
                    </div>
                    <div class="col-md-4">
                      <strong>Média</strong>
                      <div>{{formatterValue(row.item.valorMedio)}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </b-table>
          <span v-else>
            Não há itens para este filtro
          </span>
        </b-card>
      </div>
    </div>
    <BlockUI v-if="blockUI.visibility" :message="blockUI.message">
      <spinner-vue  id="modal-xl" ></spinner-vue>
    </BlockUI>
  </div>
</template>
<script>
  //  import relatoriosService from '@/services/relatorios'
  import ToastVue from '../layouts/toastVue'
  import spinnerVue from '@/components/items/SpinnerVue'
  import relatoriosService from '@/services/relatorios'
  import 'swiper/dist/css/swiper.css'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  import ProgressMetasVue from '@/components/items/ProgressMetasVue'
  import { ModelListSelect } from 'vue-search-select'

  export default {
    components: {
      ToastVue,
      spinnerVue,
      swiper,
      swiperSlide,
      ProgressMetasVue,
      ModelListSelect
    },
    props: {
      pObjClientes: {},
      pObjPaginacao: {},
      pMetasDados: {
        porCategoria: [],
        mesAtual: {}
      }
    },
    data () {
      return {
        variant: '',
        fieldsMensal: [
          {
            key: 'desempenho',
            label: ' ',
            sortable: false,
            class: 'relMetDesemp td-pg txtLeft white'
          },
          {
            key: 'valorMeta',
            label: 'Meta',
            sortable: false,
            class: 'relMetMeta txtRight',
            formatter: this.formatterValue
          },
          {
            key: 'valorAtingido',
            label: 'Atingido',
            sortable: false,
            class: 'relMetAting txtRight',
            formatter: this.formatterValue
          },
          {
            key: 'valorMedio',
            label: 'Média',
            sortable: false,
            class: 'relMetMedio txtRight',
            formatter: this.formatterValue
          },
          {
            label: '',
            key: 'mobileGeral',
            class: 'relMetGeralMobile txtLeft'
          }
        ],
        fieldsCategoria: [
          {
            key: 'categorias',
            label: 'Categorias',
            sortable: false,
            class: 'relMetDesemp td-pg txtLeft td-pg-title'
          },
          {
            key: 'valorMeta',
            label: 'Meta',
            sortable: false,
            class: 'relMetMeta txtRight',
            formatter: this.formatterValue
          },
          {
            key: 'valorAtingido',
            label: 'Atingido',
            sortable: false,
            class: 'relMetAting txtRight',
            formatter: this.formatterValue
          },
          {
            key: 'valorMedio',
            label: 'Média',
            sortable: false,
            class: 'relMetMedio txtRight',
            formatter: this.formatterValue
          },
          {
            label: '',
            key: 'mobileCategorias',
            class: 'relMetCategMobile txtLeft'
          }
        ],
        cor: '',
        slotFirstcategoria: null,
        restante: 0,
        metaAtingida: 0,
        max: 100,
        animate: true,
        blockUI: {
          message: '',
          visibility: false
        },
        categoriaTodos: {
          codigo: '',
          descricao: '',
          ordem: -100
        },
        categoriaSelecionada: {},
        options: [],
        tipoPedido: [],
        statusSelecionado: {},
        clientes: [],
        anos: [],
        anoCorrente: 0,
        anoSelecionado: 0,
        MetasAtingido: [],
        categoriasRepresentante: [],
        representanteSelecionado: {},
        representantes: [],
        categoriasTodas: {
          codigo: '',
          descricao: 'Todas as Categorias',
          ordem: -100
        },
        tableMes: []
      }
    },
    mounted () {

    },
    created () {
      this.cor = {'background-color': `#${localStorage.getItem('corApp')}`}
      // this.representantes = JSON.parse(localStorage.getItem('representantesLogin'))
      let date = new Date()
      this.anoCorrente = date.getFullYear()
      this.anoSelecionado = this.anoCorrente
      // this.anosMetas()
      // this.categoriaRepresentante()
    },
    watch: {
      pMetasDados: function (newVal, oldVal) { // watch it
        // console.log('Prop changed: ', newVal, ' | was: ', oldVal)
        this.tableMes = []
        this.tableMes.push(newVal.mesAtual)
      }
    },
    methods: {
      onChartReady (chart, google) {
        this.chartsLib = google
      },
      buscar: function () {
        this.metaXAtingido()
      },
      onChangeCategoria: function (index) {
        let categoria = this.categoriasRepresentante[index]
        this.categoriaSelecionada = categoria
        console.log(JSON.stringify(categoria))
        this.MetasAtingido = []
      },
      formatterValue: function (valor) {
        let val = (valor / 1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      },
      toCapitalize: function (value) {
        return value.replace(/\w\S*/g, function (txt) {
          return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
        })
      },
      anosMetas: function () {
        this.blockUI.visibility = true
        this.blockUI.message = 'Listando anos, aguarde...'
        relatoriosService.listarAnosMetas().then(response => {
          let anos = []
          for (let i = 0; i < response.data.anos.length; i++) {
            anos.push({ano: response.data.anos[i]})
          }
          let anosAux = anos
          anos = anosAux.sort(function (a, b) {
            return a.ano - b.ano
          })
          this.anos = anos
        }).catch(error => {
          console.log(error)
          alert('Aconteceu alguma coisa!' + error)
        }).finally(() => {
          this.blockUI.visibility = false
        })
      },
      resumoMetas: function () {
        relatoriosService.listarMetas().then(response => {
          this.atingimentoMeta = response.data
        }).catch(error => {
          console.log(error)
          alert('Aconteceu alguma coisa!' + error)
        }).finally(() => {
          this.blockUI.visibility = false
        })
      },
      categoriaRepresentante: function () {
        this.blockUI.visibility = true
        this.blockUI.message = 'Listando categorias, aguarde...'
        relatoriosService.listarCatRepresentante().then(response => {
          let categs = response.data.categorias.sort(function (a, b) {
            return a.ordem - b.ordem
          })
          categs.unshift({
            codigo: '',
            descricao: 'Todas as Categorias',
            ordem: -100
          })
          this.categoriaSelecionada = {
            codigo: '',
            descricao: 'Todas as Categorias',
            ordem: -100
          }
          this.categoriasRepresentante = categs
        }).catch(error => {
          console.log(error)
          alert('Aconteceu alguma coisa!' + error)
        }).finally(() => {
          this.blockUI.visibility = false
        })
      },
      selecionarAno: function (ano) {
        this.anoSelecionado = ano
        this.MetasAtingido = []
      },
      metaXAtingido: function () {
        let ano = this.anoSelecionado
        this.blockUI.visibility = true
        this.blockUI.message = 'Listando metas, aguarde...'
        let codigoCategoria = ''
        if (this.categoriaSelecionada !== null) {
          if (typeof this.categoriaSelecionada.codigo !== 'undefined' && this.categoriaSelecionada.codigo !== '') {
            codigoCategoria = this.categoriaSelecionada.codigo
          }
        }
        let parametros = {ano: ano, codCategoria: codigoCategoria}
        relatoriosService.MetasVsAtingido(parametros).then(response => {
          this.MetasAtingido = response.data.metas.sort(function (a, b) {
            return a.periodo - b.periodo
          })
        }).catch(error => {
          console.log(error)
          alert('Aconteceu alguma coisa!' + error)
        }).finally(() => {
          this.blockUI.visibility = false
        })
      }
    }
  }
</script>
<style scoped>
  .table{
    font-size: 14px;
  }
  .imgTable {
    width: 50px !important;
  }
  .progressbar{
    counter-reset: step;
  }
  .progressbar button {
    display: inline;
    float: left;
    position: relative;
    text-align: center;
    color: #fff;
    border-radius: 18px;
    line-height: 34px;
  }
  .color {
    background-color: rgb(55, 71, 79);
  }
  .colorSelec {
    background-color: rgb(38, 50, 56);
  }

  .ui.fluid.dropdown {
    line-height: 0.2em !important;
    /* height: 1.9rem; */
    min-height: initial !important
  }

  .ui.search.dropdown > .text[data-v-3a0c7bea] {
    font-size: 14px !important;
  }
  .ui.selection.dropdown .menu > .item[data-v-3a0c7bea] {
    padding: 0.78571429rem 1.14285714rem !important;
    font-size: 14px !important;
  }
  .ui.selection.dropdown[data-v-3a0c7bea] {
    line-height: 1em !important;
    padding: 0.6em 2.1em 0.6em 1em !important;
  }
  svg {
    overflow: visible;
  }
  .label-categoria {
    color: #4d4d4d;
  }
  .table td, .table th {
    padding: 0.2rem;
  }
  .card-body {
    position: relative;
  }
  .titulo-mes {
    position: absolute;
    z-index: 3;
  }
</style>



// WEBPACK FOOTER //
// src/components/items/relatorioMetasVue.vue